(function mainmenuScript(Drupal, $, once) {
  Drupal.behaviors.menu_block_main_navigation = {
    attach(context) {
      const $menuToggle = $('.menu-toggle', context);
      const $mainMenu = $('.main-navigation .main-navigation__menu', context);
      const $headerMenu = $('.menu--header-menu .header-menu', context);

      function mainMenu() {
        if (window.matchMedia('(min-width: 961px)').matches) {
          $mainMenu.show();
          $mainMenu.find('.header-menu').remove();
        } else {
          if (!$mainMenu.hasClass('open')) {
            $mainMenu.hide();
          }
          if ($mainMenu.find('.header-menu').length === 0) {
            $mainMenu.append($headerMenu.clone());
            $mainMenu
              .find('.header-menu > li:not(.menu-item__level-0)')
              .addClass('menu-item__level-0')
              .find('a')
              .wrapInner('<span class="menu-item__title"></span>');
          }
          const $headerHeight = $('.above-header').height();
          $mainMenu.css('top', $headerHeight + 'px');
        }
        $menuToggle.unbind().click(() =>
          $mainMenu
            .slideToggle()
            .toggleClass('open')
            .closest('body')
            .toggleClass('hide-overflow')
        );
        $('html').addClass('js-mobile-menu');
      }
      mainMenu();
      $(window).resize(() => mainMenu());

      // if main menu item has children add toggle button to show/hide child items.
      function subMenus() {
        function openSubMenu(elem) {
          elem.addClass('open');
          elem.children('a').attr('aria-expanded', 'true');
          elem.children('button').attr('aria-expanded', 'true');
        }

        function closeSubMenu(elem) {
          elem.removeClass('open');
          elem.children('a').attr('aria-expanded', 'false');
          elem.children('button').attr('aria-expanded', 'false');
        }

        $(
          '.main-navigation__menu .menu-item__level-0.has-submenu',
          context
        ).each(function menuItems() {
          const $activatingA = $(once('menu_block_main_navigation', $(this).children('a'))); // $(this).children('a');
          const btn = `<button class="submenu-toggle"><span class="visually-hidden">show submenu for “
            ${$activatingA.text()}
            ”</span><svg class="submenu-toggle__icon"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 29"><path fill="#1D2E56" fill-rule="evenodd" d="M.8 26.8a1 1 0 0 0 0 1.4c.4.4 1 .4 1.4 0l13-13c.4-.4.4-1 0-1.4L2.2.8A1 1 0 0 0 .8.8a1 1 0 0 0 0 1.4L13 14.5.8 26.8z"/></svg></button>`;

          $(btn).insertAfter($activatingA);
          $activatingA.attr('aria-expanded', 'false');
          $activatingA.next('button').attr('aria-expanded', 'false');
        });

        const $submenuParent = $(
          '.main-navigation__menu .menu-item__level-0.has-submenu',
          context
        );
        const $submenuToggle = $(
          '.main-navigation__menu .menu-item__level-0.has-submenu > button.submenu-toggle',
          context
        );

        $submenuToggle.unbind().click(function toggleSubmenus() {
          const $parent = $(this).parent();
          if (!$parent.hasClass('open')) {
            openSubMenu($parent);
          } else {
            closeSubMenu($parent);
          }
        });

        if (window.matchMedia('(min-width: 961px)').matches) {
          $submenuParent.focusin(function() {
            openSubMenu($(this));
          });
          $submenuParent.focusout(function() {
            const $elem = $(this);
            setTimeout(function() {
              const hasFocus = !!($elem.find(':focus').length > 0);
              if (hasFocus === false) {
                closeSubMenu($elem);
              }
            }, 10);
          });

          $submenuParent.hover(
            function() {
              openSubMenu($(this));
            },
            function() {
              setTimeout(closeSubMenu, 500, $(this));
            }
          );
        }
        $('html').addClass('js-submenus');
      }
      subMenus();
    }
  };
}(Drupal, jQuery, once));
